import { CSSProperties } from 'react';
import { Chip as MuiChip } from '@mui/material';
import { useLocalization } from 'localization';
import { colors } from 'theme/mui/colors';

type Props = {
  styles?: CSSProperties;
  label: string;
};

const Chip = (props: Props) => {
  const { t } = useLocalization();
  const { label, styles = {} } = props;

  return (
    <MuiChip
      label={t(label)}
      sx={{
        backgroundColor: colors.blue.level10,
        color: colors.blue.level60,
        fontSize: '0.75rem',
        height: '1.5rem',
        '& .MuiChip-label': {
          padding: '0.25rem 0.5rem',
          ...styles,
        },
      }}
    />
  );
};

export default Chip;
